import { RequestMethod } from '@shiyanjia/utils';
import { message } from "antd-v5";

function handleLogin(error, loginErrorCode) {
  if (RequestMethod.checkRequestError(error) && error.errorCode === loginErrorCode) {
    window.location.href = `/login?redirect=${window.btoa(window.location.href)}`;
  }
}

function handleMessage(error) {
  message.error(error.message);
  throw error;
}

function loginInterceptor(loginCode) {
  return interceptors => {
    interceptors.response.use(
      response => response,
      error => {
        handleLogin(error, loginCode);
        throw error;
      },
    );
  }
}

const sApi = new RequestMethod({
  baseURL: process.env.REACT_APP_URL,
  withCredentials: true,
  interfaceMapping: {
    statusCode: 'code',
    statusMessage: 'msg',
    data: 'data',
  },
  successCode: 200,
  customInterceptors: loginInterceptor(401),
});

const nextCrmApi = new RequestMethod({
  baseURL: process.env.REACT_APP_NEXT_CRM_BASEURL,
  withCredentials: true,
  customInterceptors: loginInterceptor(1),
});

/**
 * 按照新的接口规范处理请求响应数据
 */
const sApiStandard = new RequestMethod({
  baseURL: process.env.REACT_APP_URL,
  withCredentials: true,
  customInterceptors: loginInterceptor(1),
});

const dsApi = new RequestMethod({
  baseURL: process.env.REACT_APP_DATA_SERVICE_URL,
  withCredentials: true,
  interfaceMapping: {
    statusCode: 'code',
    statusMessage: 'msg',
    data: 'data',
  },
  customInterceptors: loginInterceptor(1),
});

export { handleMessage, sApi, sApiStandard, dsApi, nextCrmApi };
